import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import userContextSlice from '@/common/slices/userContextSlice';
import { useGuidedExperience } from './GuidedExperienceProvider';

/**
 * SummaryPage — navigates immediately back to the Analytics tab while opening
 * the Welcome Tour modal. Because GuidedExperienceProvider lives above the
 * router, the modal persists across the navigation so users can replay the
 * full guided experience at any time from the nav.
 */
const SummaryPage: React.FC = () => {
  const { startExperience } = useGuidedExperience();
  const selectedTeamId = useSelector(userContextSlice.selectors.getSelectedTeamId as any) as number | undefined;
  const navigate = useNavigate();

  useEffect(() => {
    startExperience('welcome-tour');
    navigate('/app/culture-hub/analytics', { replace: true });
  }, [startExperience, navigate]);

  return null;
};

export default SummaryPage;
